import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from './client'
import { attackPatternAdapter, csvMitreAdapter } from '@/adapters'
import { useCallback } from 'react'

const adapters = [
  ['default', attackPatternAdapter],
  ['csv-mitre', csvMitreAdapter],
  ['__raw', (data) => data],
]

export const query = async ({ api, type, ids }) => {
  const data = await api.getAttackPattern({ type, ids })
  const adaptedData = await Promise.all(adapters.map(([key, adapter]) => {
    return adapter(data, { type, ids })
  }))
  return adaptedData.reduce((acc, curr, i) => {
    acc[adapters[i][0]] = curr
    return acc
  }, {})
}

export const useAttackPatternQuery = (type, options = {}) => {
  if (!type) {
    console.warn('useAttackPatternQuery requires a type')
  }
  const api = useMatiApiClient('attackPatterns')
  const { ids, adapter = false, ...restOptions } = options
  if (ids && !Array.isArray(ids)) {
    throw new Error('ids option must be an array')
  }
  if (adapter && typeof adapter !== 'string' && typeof adapter !== 'boolean') {
    throw new Error('adapter option must be a string or a boolean')
  }
  const adapterFn = adapters.find(([key]) => key === adapter || (adapter === true && key === 'default') || (adapter === false && key === '__raw'))
  const enabled = !!type && !!ids?.length

  return useQuery({
    queryFn: () => query({ api, type, ids }),
    queryKey: ['getAttackPattern', type, ids, adapter],
    select: useCallback(data => data[adapterFn[0]] || data.__raw, [adapterFn]),
    ...restOptions,
    enabled: (restOptions.enabled ?? true) && enabled,
  })
}
